import React from "react";
import InputField from "../reusableComponents/InputField";
import SubmitButton from "../reusableComponents/SubmitButton";
import UserStore from "../../stores/UserStore";
import { Link } from "react-router-dom";
import { DropdownList, Multiselect } from "react-widgets";
import Can from "../authentication/Can";
import { alertService } from "../common/alert.service";
import { emailValidate, phoneValidate } from "../common/inputValidationHelpers";

class UserEditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: props.user,
      buttonDisabled: false,
      positionsList: [],
      departmentsList: [],
      employeesList: [],
      addressList: [],
      locationsList: [],
      roles: [],
    };
  }

  async componentDidMount() {
    this.getPositions();
    this.getDepartments();
    this.getEmployees();
    this.getAddresses();
    this.getLocations();
    this.getPermissions();
  }

  async getPermissions() {
    if (!UserStore.isLoggedIn || !UserStore.username) {
      return;
    }
    try {
      let res = await fetch("/getPermissions", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          roles: result.permissions,
        });
      } else if (result && result.success === false) {
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getPositions() {
    try {
      let res = await fetch("/getPositions", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({ positionsList: result.positions });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }
  async getDepartments() {
    try {
      let res = await fetch("/getDepartments", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({ departmentsList: result.departments });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }
  async saveUser() {
    if (
      !this.state.user ||
      this.state.user.first_name === "" ||
      this.state.user.last_name === "" ||
      emailValidate(this.state.user.email) ||
      !this.state.user.position ||
      !this.state.user.department ||
      !this.state.user.location ||
      (this.state.user.phone && !phoneValidate(this.state.user.phone))
    ) {
      alertService.warn(
        "Missing Info. Please ensure you have filled in all the details before saving."
      );
      return;
    }

    this.setState({ buttonDisabled: true });
    try {
      let res = await fetch("/saveUser", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user: this.state.user,
        }),
      });

      let result = await res.json();
      if (result && result.success) {
        alertService.success("Saved Credentials");
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
    this.setState({ buttonDisabled: false });
  }

  async getEmployees() {
    try {
      let res = await fetch("/getEmployees", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({ employeesList: result.employees });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }
  async getAddresses() {
    try {
      let res = await fetch("/getAddresses", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({ addressList: result.addresses });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }
  async getLocations() {
    try {
      let res = await fetch("/getLocations", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({ locationsList: result.locations });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.doLogin();
    }
  }

  render() {
    return (
      <>
        <div className="transparent box wide center">
          <h1>Edit User Details:</h1>
          <div className="grid2by2">
            <span>First Name:</span>
            <span>Last Name:</span>
            <InputField
              type="text"
              placeholder="First Name"
              value={
                this.state.user.first_name ? this.state.user.first_name : ""
              }
              onChange={(val) =>
                this.setState((prevState) => ({
                  user: {
                    ...prevState.user,
                    first_name: val,
                  },
                }))
              }
              onKeyDown={(e) => {}}
            />
            <InputField
              type="text"
              placeholder="Last Name"
              value={this.state.user.last_name ? this.state.user.last_name : ""}
              onChange={(val) =>
                this.setState((prevState) => ({
                  user: {
                    ...prevState.user,
                    last_name: val,
                  },
                }))
              }
              onKeyDown={(e) => {}}
            />
            <span>Email:</span>
            <span>Phone Number:</span>
            <InputField
              type="text"
              placeholder="Email"
              value={this.state.user.email ? this.state.user.email : ""}
              onChange={(val) =>
                this.setState((prevState) => ({
                  user: {
                    ...prevState.user,
                    email: val,
                  },
                }))
              }
              onKeyDown={(e) => {}}
            />

            <InputField
              type="text"
              placeholder="Phone Number"
              value={this.state.user.phone ? this.state.user.phone : ""}
              onChange={(val) =>
                this.setState((prevState) => ({
                  user: {
                    ...prevState.user,
                    phone: val,
                  },
                }))
              }
              onKeyDown={(e) => {}}
            />
          </div>
          <Can
            role={UserStore.permissions}
            perform="users:edit"
            yes={() => (
              <>
                <div className="grid2by2">
                  <span>Position:</span>
                  <span>Department:</span>
                  <DropdownList
                    className="red"
                    filter
                    data={this.state.positionsList}
                    textField="name"
                    value={this.state.user.position}
                    onChange={(val) =>
                      this.setState((prevState) => ({
                        user: {
                          ...prevState.user,
                          position: val,
                        },
                      }))
                    }
                  />
                  <DropdownList
                    filter
                    data={this.state.departmentsList}
                    textField="name"
                    value={this.state.user.department}
                    onChange={(val) =>
                      this.setState((prevState) => ({
                        user: {
                          ...prevState.user,
                          department: val,
                        },
                      }))
                    }
                  />
                  <span>Location:</span>
                  <span>Supervisor:</span>
                  <DropdownList
                    filter
                    data={this.state.locationsList}
                    textField="name"
                    value={this.state.user.location}
                    onChange={(val) =>
                      this.setState((prevState) => ({
                        user: {
                          ...prevState.user,
                          location: val,
                        },
                      }))
                    }
                  />
                  <DropdownList
                    filter
                    data={this.state.employeesList}
                    textField="name"
                    value={this.state.user.supervisor}
                    onChange={(val) =>
                      this.setState((prevState) => ({
                        user: {
                          ...prevState.user,
                          supervisor: val,
                        },
                      }))
                    }
                  />
                </div>
                Address:
                <DropdownList
                  filter
                  data={this.state.addressList}
                  textField="name"
                  value={this.state.user.address}
                  onChange={(val) =>
                    this.setState((prevState) => ({
                      user: {
                        ...prevState.user,
                        address: val,
                      },
                    }))
                  }
                />
                Permissions:
                <Multiselect
                  data={this.state.roles}
                  textField="name"
                  value={this.state.user.permissions}
                  onChange={(val) =>
                    this.setState((prevState) => ({
                      user: {
                        ...prevState.user,
                        permissions: val,
                      },
                    }))
                  }
                />
              </>
            )}
            no={() => (
              <>
                Position:
                <DropdownList
                  filter
                  disabled
                  data={this.state.positionsList}
                  textField="name"
                  value={this.state.user.position}
                  onChange={(val) =>
                    this.setState((prevState) => ({
                      user: {
                        ...prevState.user,
                        position: val,
                      },
                    }))
                  }
                />
                Department:
                <DropdownList
                  filter
                  disabled
                  data={this.state.departmentsList}
                  textField="name"
                  value={this.state.user.department}
                  onChange={(val) =>
                    this.setState((prevState) => ({
                      user: {
                        ...prevState.user,
                        department: val,
                      },
                    }))
                  }
                />
                Location:
                <DropdownList
                  filter
                  disabled
                  data={this.state.locationsList}
                  textField="name"
                  value={this.state.user.location}
                  onChange={(val) =>
                    this.setState((prevState) => ({
                      user: {
                        ...prevState.user,
                        location: val,
                      },
                    }))
                  }
                />
                Supervisor:
                <DropdownList
                  filter
                  disabled
                  data={this.state.employeesList}
                  textField="name"
                  value={this.state.user.supervisor}
                  onChange={(val) =>
                    this.setState((prevState) => ({
                      user: {
                        ...prevState.user,
                        supervisor: val,
                      },
                    }))
                  }
                />
                Address:
                <DropdownList
                  filter
                  disabled
                  data={this.state.addressList}
                  textField="name"
                  value={this.state.user.address}
                  onChange={(val) =>
                    this.setState((prevState) => ({
                      user: {
                        ...prevState.user,
                        address: val,
                      },
                    }))
                  }
                />
                Permissions:
                <Multiselect
                  data={this.state.roles}
                  disabled
                  textField="name"
                  value={this.state.user.permissions}
                  onChange={(val) =>
                    this.setState((prevState) => ({
                      user: {
                        ...prevState.user,
                        permissions: val,
                      },
                    }))
                  }
                />
              </>
            )}
          />
          <Link to="/forgot">
            <div className="hyper-link">Send Password Reset</div>
          </Link>
          <SubmitButton
            text="Save"
            disabled={this.state.buttonDisabled}
            onClick={() => {
              this.saveUser();
            }}
          />
        </div>
      </>
    );
  }
}

export default UserEditForm;
